import { render, staticRenderFns } from "./PageHeaderLayout.vue?vue&type=template&id=6fe099e5&scoped=true&"
import script from "./PageHeaderLayout.vue?vue&type=script&lang=js&"
export * from "./PageHeaderLayout.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderLayout.vue?vue&type=style&index=0&id=6fe099e5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe099e5",
  null
  
)

export default component.exports